// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiCircleOutlinedSvg from "@fishx/icons-svg/es/asn/CiCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var CiCircleOutlined = function CiCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleOutlinedSvg
  }));
};

CiCircleOutlined.displayName = 'CiCircleOutlined';
export default React.forwardRef(CiCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CiCircleOutlined.js
// module id = 2207
// module chunks = 0